/* import __COLOCATED_TEMPLATE__ from './seller-profile-project-list.hbs'; */
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { A } from '@ember/array';
import Component from '@ember/component';

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: 'section',
  classNames: ['SH-c-seller-profile-project-list'],
  classNameBindings: ['_isHasNoProjects:hide'],

  userCommandService : service('commands/user-commands'),
  media: service(),
  session: service(),

  pagination: null,

  hasError: false,

  /** @param {Boolean} projectsAreLoading */
  areProjectsLoading: false,

  /** @param {Ember.A} projectDigestsSorted */
  projectDigestsSorted: A([]),

  /** @param {Function} showFeaturedDigestInModal */
  showFeaturedDigestInModal: () => {},

  /** @type {function(Object): Promise<any>} */
  updateReview: null,

  /** @type {Boolean} Whether we have no projects for the user at all. */
  _isHasNoProjects: computed('pagination.total', function(){
    return this.pagination?.total < 1;
  }),

  actions: {
    /** @param {Function} */
    setPinned(projectdigestId, isPinned){
      return this.userCommandService.setProjectPinned(projectdigestId, isPinned);
    },
  },

});
